import * as React from "react";
import BaseCard from "../Cards/BaseCard";
import { Post } from "@pulsex/types";
import SectionTitle from "../Title/SectionTitle";
import { cn } from "@pulsex/utils";

export interface IBaseGrid {
    title: string;
    posts?: Post[];
    renderItem?: (post: Post, index: number) => React.ReactNode;
    className?: string;
    titleClassName?: string;
    moreLink?: string;
    itemsPerRow?: number;
    author?: boolean;
    resolution?: number;
}

const BasicGrid: React.FC<IBaseGrid> = ({
    title,
    posts,
    renderItem,
    moreLink,
    className,
    titleClassName,
    itemsPerRow = 3,
    author = true,
    resolution = 3,
}) => {
    return (
        <section className={cn("container mx-auto  my-5", className)}>
            <SectionTitle title={title} more={moreLink} />
            <div
                className={cn(
                    "grid grid-cols-3 gap-5",
                    itemsPerRow && `grid-cols-${itemsPerRow}`,
                    "lg:flex lg:overflow-scroll lg:gap-2"
                )}
            >
                {posts?.map((post, i) => (
                    <React.Fragment key={i}>
                        {renderItem ? (
                            renderItem(post, i)
                        ) : (
                            <BaseCard
                                variant="opened"
                                author={author}
                                post={post}
                                titleClassName={titleClassName}
                                resolution={resolution}
                            />
                        )}
                    </React.Fragment>
                ))}
            </div>
        </section>
    );
};

export default BasicGrid;
